import React from "react";
import "./Homepage.scss";
import NavBar from "../Navbar/Navbar";
import Hero from "../Hero/Hero";
import Footer from "../Footer/Footer";

const Homepage = () => {
	return (
		<main className="container justify-between is-flex-direction-column">
			<NavBar active="home" />
			<Hero />
			<Footer />
		</main>
	);
};

export default Homepage;
